import React from 'react';
import { renderTextWithBold } from '@/utils/dashboardTextFormat';

export interface ReportSectionHeaderProps {
  level: 1 | 2 | 3;
  text: string;
}

export function ReportSectionHeader({ level, text }: ReportSectionHeaderProps) {
  const trimmed = (text || '').trim();
  if (!trimmed) return null;

  const textClassName =
    level === 1
      ? 'text-2xl md:text-3xl font-bold tracking-tight text-gray-800 dark:text-gray-200'
      : level === 2
        ? 'text-xl md:text-2xl font-semibold tracking-tight text-gray-800 dark:text-gray-200 mt-6 first:mt-0'
        : 'text-lg md:text-xl font-medium tracking-tight text-gray-700 dark:text-gray-300 mt-4 first:mt-0';

  const HeadingTag = level === 1 ? 'h1' : level === 2 ? 'h2' : 'h3';

  return (
    <div className="flex items-end w-full gap-3">
      <HeadingTag className={`${textClassName} shrink-0`}>{renderTextWithBold(trimmed)}</HeadingTag>
      <div
        className="flex-1 min-w-[24px] border-b border-gray-200 dark:border-gray-600/80 mb-0.5"
        aria-hidden
      />
    </div>
  );
}
